import {
  ADD_VEHICLE_MAKE,
  GET_ROLES_PERMISSIONS,
  GET_VEHICLE_MAKE,
  GET_VEHICLE_MAKE_DETAILS,
  UPDATE_VEHICLE_MAKE,
  DELETE_VEHICLE_MAKE,
  UPDATE_VEHICLE_MAKE_STATUS,
  VEHICLE_MAKE_LIST
} from "helpers/url_helper";
import { createCrudSlice } from "./createCrudSlice";

const rolesSlice = createCrudSlice({
  name: "vehicleMake",
  urls: {
    getList: GET_VEHICLE_MAKE,
    getDropdownList: VEHICLE_MAKE_LIST,
    add: ADD_VEHICLE_MAKE,
    update: UPDATE_VEHICLE_MAKE,
    delete: DELETE_VEHICLE_MAKE,
    updateStatus: UPDATE_VEHICLE_MAKE_STATUS,
    getDetails: GET_VEHICLE_MAKE_DETAILS,
  },
  initialFilters: {},
  hasDropdownList: true,
  defaultDropdownData: [],
  additionalThunks: {
    getRolesPermissions: {
      url: GET_ROLES_PERMISSIONS,
      method: "get",
      stateKey: "permissions",
    },
  },
  initialState: {
  },
});

// Export actions
export const { setFilter, resetFilters } = rolesSlice.actions;

// Export thunks
export const {
  getList: getVehicleMakeList,
  getDropdownList: getVehicleMakeDropdownlist,
  add: addVehicleMake,
  update: updateVehicleMake,
  delete: deleteVehicleMake,
  updateStatus: updateVehicleMakeStatus,
  getDetails: getVehicleMakeDetails,
  getRolesPermissions,
} = rolesSlice.thunks;

// Export reducer
export default rolesSlice.reducer;
